"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timer = void 0;
function timer(now) {
    var st = now();
    return function stop() {
        return Math.round(now() - st);
    };
}
exports.timer = timer;
